import { Component, inject } from '@angular/core';
import { SpinnerService } from '../../../../services/spinner/spinner-service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner-component',
  imports: [CommonModule],
  templateUrl: './spinner-component.html',
  styleUrl: './spinner-component.scss'
})
export class SpinnerComponent {

  private spinnerService = inject(SpinnerService)

  loading$ = this.spinnerService.loading$;

}
